import axios from "axios";

class HttpSingleton {
  static instance;
  client = axios.create();

  constructor() {
    if (HttpSingleton.instance) {
      return HttpSingleton.instance;
    }

    this.client.defaults.baseURL =
      import.meta.env.VITE_BASE_URL || "https://devffservice.freefit.co.il/MobileManagementService/";

    this.client.defaults.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    this.client.defaults.timeout = 30000;

    this.client.interceptors.request.use((config) => this.#requestInterceptor(config));

    this.client.interceptors.response.use(
      (res) => this.#successInterceptor(res),
      (err) => this.#errorInterceptor(err)
    );

    HttpSingleton.instance = this;
  }

  #requestInterceptor(config) {
    const correlationId = localStorage.getItem("CorrelationId");
    if (correlationId && config?.headers) {
      const headers = { ...config.headers, "X-Correlation-Id": correlationId };
      config.headers = headers;
    }
    return config;
  }

  #successInterceptor(res) {
    return res;
  }

  #errorInterceptor(err) {
    return Promise.reject(err);
  }

  async get(url) {
    const response = await this.client.get(`/${url}`);
    return response;
  }

  async post(url, body) {
    const response = await this.client.post(`/${url}`, body);
    return response;
  }

  async put(url, body) {
    const response = await this.client.put(`/${url}`, body);
    return response;
  }

  async delete(url) {
    const response = await this.client.delete(`/${url}`);
    return response;
  }
}

const httpSingleton = new HttpSingleton();
export default httpSingleton;
